exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table th[data-v-5efe12bc]{background-color:#f8f9fa;position:sticky;top:0;z-index:10}", ""]);

// exports
